export type EnvName = "" | "local" | "dev" | "lab" | "test" | "stag" | "prod";
export type Environment = {
  name: EnvName | string;
  apiEndPoint: string;
  assetEndPoint: string;
};

// Default configurations for each environment
const DEFAULT_CONFIGS = {
  local: {
    apiEndPoint: "https://qjb1ln0v-30001.asse.devtunnels.ms/data-user/form",
    assetEndPoint: "https://apistag.taptap.com.vn/tcl/v4/b2b/user-data/survey/mobile/",
  },
  stag: {
    apiEndPoint: "https://apistag.taptap.com.vn/taptap-webapp-proxy/v1/data-user/form/",
    assetEndPoint: "https://apistag.taptap.com.vn/tcl/v4/b2b/user-data/survey/mobile/",
  },
  prod: {
    apiEndPoint: "https://api-v2.taptap.com.vn/taptap-webapp-proxy/v1/data-user/form/",
    assetEndPoint: "https://api.taptap.com.vn/tcl/v4/b2b/user-data/survey/mobile/",
  }
};

function getEnvironmentConfig(): Environment {
  console.log(process.env)
  console.log('REACT_APP_ENV', process.env.REACT_APP_ENV );
  console.log('REACT_APP_ASSET_ENDPOINT_STAG', process.env.REACT_APP_ASSET_ENDPOINT_STAG);

  const currentEnv = process.env.REACT_APP_ENV || "stag";
  
  // For local environment, use direct environment variables
  if (currentEnv === "local") {
    return {
      name: "local",
      apiEndPoint: process.env.REACT_APP_API_ENDPOINT || DEFAULT_CONFIGS.local.apiEndPoint,
      assetEndPoint: process.env.REACT_APP_ASSET_ENDPOINT || DEFAULT_CONFIGS.local.assetEndPoint,
    };
  }
  
  console.log(currentEnv)

  // For staging and production, use suffixed environment variables
  // const envKey = currentEnv.toLowerCase() as keyof typeof DEFAULT_CONFIGS;
  // const defaultConfig = DEFAULT_CONFIGS[envKey] || DEFAULT_CONFIGS.stag;

  // const apiEndpoint = process.env[`REACT_APP_API_ENDPOINT_${currentEnv.toUpperCase()}`] || defaultConfig.apiEndPoint;
  // const assetEndpoint = process.env[`REACT_APP_ASSET_ENDPOINT_${currentEnv.toUpperCase()}`] || defaultConfig.assetEndPoint;

  let apiEndpoint = DEFAULT_CONFIGS.local.apiEndPoint;
  let assetEndpoint = DEFAULT_CONFIGS.local.assetEndPoint;
  switch (currentEnv) {
    case 'stag':
      apiEndpoint =
        process.env.REACT_APP_API_ENDPOINT_STAG ||
        DEFAULT_CONFIGS.stag.apiEndPoint;
      assetEndpoint =
        process.env.REACT_APP_ASSET_ENDPOINT_STAG ||
        DEFAULT_CONFIGS.stag.assetEndPoint;
      break;
    case 'prod':
      apiEndpoint =
        process.env.REACT_APP_API_ENDPOINT_PROD ||
        DEFAULT_CONFIGS.prod.apiEndPoint;
      assetEndpoint =
        process.env.REACT_APP_ASSET_ENDPOINT_PROD ||
        DEFAULT_CONFIGS.prod.assetEndPoint;
  }

  console.log(apiEndpoint, assetEndpoint);

  return {
    name: currentEnv,
    apiEndPoint: apiEndpoint,
    assetEndPoint: assetEndpoint,
  };
}

export function getEnv(): Environment {
  return getEnvironmentConfig();
}
